import {
  getOrCreateAttributionContext,
  toMixpanelAdditionalInfo
} from './mixpanelAttribution'
import type { MixpanelAdditionalInfo } from './mixpanelTypes'

export type { MixpanelAdditionalInfo } from './mixpanelTypes'

export function getMixpanelAdditionalInfo(): MixpanelAdditionalInfo {
  const context = getOrCreateAttributionContext({
    url: new URL(window.location.href),
    referrer: document.referrer
  })

  return toMixpanelAdditionalInfo(context, window.location.pathname)
}

export async function waitForMixpanelAdditionalInfo(): Promise<MixpanelAdditionalInfo> {
  return getMixpanelAdditionalInfo()
}
